import { lazy } from 'react';
// ----------------------------------------------------------------------

const SubscriptionRequestPage = lazy(() => import('../pages/SubscriptionRequest.page'));
// const AddSubscriptionRequest = lazy(() => import('../pages/AddSubscriptionRequest.page'));
// const OrderDetailsPage = lazy(() => import('../pages/OrderDetailsPage'));

// ----------------------------------------------------------------------

const SubscriptionRequestRoutes = [
    {
        path: '/subscriptions',
        children: [
            { element: <SubscriptionRequestPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: '/subscriptions/subscription-request',
                element: <SubscriptionRequestPage />,
                layout: 'default',
                isAuthReq: true,
            },
            // { path: 'order-list/:id', element: <OrderDetailsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { SubscriptionRequestRoutes };
